const messages = {
  'sidebar.app': 'App',
};

const locales = {
  messages,
  locale: 'en',
};
export default locales;
